import { render, staticRenderFns } from "./TableMessages.vue?vue&type=template&id=69dadf32&"
import script from "./TableMessages.vue?vue&type=script&lang=js&"
export * from "./TableMessages.vue?vue&type=script&lang=js&"
import style0 from "./TableMessages.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports